module.exports = [
  {
    "stateCode": "01",
    "LE": 75
  },
  {
    "stateCode": "02",
    "LE": 79
  },
  {
    "stateCode": "04",
    "LE": 79
  },
  {
    "stateCode": "05",
    "LE": 76
  },
  {
    "stateCode": "06",
    "LE": 80
  },
  {
    "stateCode": "08",
    "LE": 80
  },
  {
    "stateCode": "09",
    "LE": 80
  },
  {
    "stateCode": "10",
    "LE": 78
  },
  {
    "stateCode": "11",
    "LE": 77
  },
  {
    "stateCode": "12",
    "LE": 79
  },
  {
    "stateCode": "13",
    "LE": 77
  },
  {
    "stateCode": "15",
    "LE": 81
  },
  {
    "stateCode": "16",
    "LE": 79
  },
  {
    "stateCode": "17",
    "LE": 79
  },
  {
    "stateCode": "18",
    "LE": 77
  },
  {
    "stateCode": "19",
    "LE": 79
  },
  {
    "stateCode": "20",
    "LE": 78
  },
  {
    "stateCode": "21",
    "LE": 76
  },
  {
    "stateCode": "22",
    "LE": 76
  },
  {
    "stateCode": "23",
    "LE": 79
  },
  {
    "stateCode": "24",
    "LE": 79
  },
  {
    "stateCode": "25",
    "LE": 81
  },
  {
    "stateCode": "26",
    "LE": 78
  },
  {
    "stateCode": "27",
    "LE": 81
  },
  {
    "stateCode": "28",
    "LE": 75
  },
  {
    "stateCode": "29",
    "LE": 77
  },
  {
    "stateCode": "30",
    "LE": 79
  },
  {
    "stateCode": "31",
    "LE": 79
  },
  {
    "stateCode": "32",
    "LE": 78
  },
  {
    "stateCode": "33",
    "LE": 80
  },
  {
    "stateCode": "34",
    "LE": 80
  },
  {
    "stateCode": "35",
    "LE": 79
  },
  {
    "stateCode": "36",
    "LE": 81
  },
  {
    "stateCode": "37",
    "LE": 78
  },
  {
    "stateCode": "38",
    "LE": 80
  },
  {
    "stateCode": "39",
    "LE": 77
  },
  {
    "stateCode": "40",
    "LE": 76
  },
  {
    "stateCode": "41",
    "LE": 79
  },
  {
    "stateCode": "42",
    "LE": 79
  },
  {
    "stateCode": "44",
    "LE": 79
  },
  {
    "stateCode": "45",
    "LE": 77
  },
  {
    "stateCode": "46",
    "LE": 80
  },
  {
    "stateCode": "47",
    "LE": 76
  },
  {
    "stateCode": "48",
    "LE": 78
  },
  {
    "stateCode": "49",
    "LE": 80
  },
  {
    "stateCode": "50",
    "LE": 81
  },
  {
    "stateCode": "51",
    "LE": 79
  },
  {
    "stateCode": "53",
    "LE": 80
  },
  {
    "stateCode": "54",
    "LE": 76
  },
  {
    "stateCode": "55",
    "LE": 78
  },
  {
    "stateCode": "56",
    "LE": 80
  }
]
